<template>
    <b-link variant="link" @click="deleteEntry">Delete</b-link>
</template>

<script>
export default {
  props: ['photo'],
  methods: {
    deleteEntry() {
      if (confirm('Are you sure you want to remove this photo?')) {
        this.$store.dispatch('photo/deletePhoto', this.photo)
      }
    }
  }
}
</script>

<style scoped>
</style>
